
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/migracja-numeru/prepaid/wybierz-date-migracji",
      function () {
        return require("private-next-pages/migracja-numeru/prepaid/wybierz-date-migracji.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/migracja-numeru/prepaid/wybierz-date-migracji"])
      });
    }
  